import { Navigate, RouteObject } from 'react-router'
import { SettingsPage } from '../pages/settings'
import { GeneralTab } from '../pages/tabs/general'
import { BillingTab } from '../pages/tabs/billing'
import { OnlineBookingTab } from '../pages/tabs/online-booking'
import { NotificationsTab } from '../pages/tabs/notifications'
import { CreateLocationModal } from '../components/locations/create-location-modal'
import { ProfileTab } from '../pages/tabs/profile/profile'
import { UpdateLocationModal } from '../components/locations/update-location-modal'
import { EditBusinessDetailsModal } from '../pages/edit-business-details'
import { SizesPage } from '../pages/tabs/pet-options/sizes'
import { CoatsPage } from '../pages/tabs/pet-options/coats'
import { CreateSizeCategoryModal } from '../components/pet-options/create-size-category-modal'
import { UpdateSizeCategoryModal } from '../components/pet-options/update-size-category-modal'
import { CreateCoatTypeModal } from '../components/pet-options/create-coat-type-modal'
import { UpdateCoatTypeModal } from '../components/pet-options/update-coat-type-modal'
import { Role } from '$api-client/types.gen'
import { RequireRole } from '$components'
import { Router } from '$utils/router'

export enum SettingsRoutePath {
  Settings = '/settings',
  SettingsGeneral = 'general',
  SettingsLocationCreate = 'locations/create',
  SettingsLocationUpdate = 'locations/update/:locationId',
  SettingsBusinessNameEdit = 'business-name-edit',
  SettingsNotification = 'notification',
  SettingsBilling = 'billing',
  SettingsOnlineBooking = 'online-booking',

  // Pet Options
  SettingsPetOptions = 'pet-options',
  SettingsPetOptionsSizes = 'pet-options/sizes',
  SettingsPetOptionsCoats = 'pet-options/coats',
  SettingsSizeCategoryUpdate = 'sizes/:sizeCategoryId/edit',
  SettingsCoatTypeUpdate = 'coats/:coatTypeId/edit',

  // Personal
  SettingsProfile = 'profile',
}

export const protectedSettingsRoutes: RouteObject[] = [
  {
    path: SettingsRoutePath.Settings,
    element: <SettingsPage />,
    children: [
      {
        index: true,
        element: <Navigate
          to={SettingsRoutePath.SettingsGeneral}
          replace
        />,
      },
      {
        path: SettingsRoutePath.SettingsGeneral,
        element: (
          <RequireRole
            roles={[Role.SUPER_ADMIN, Role.ADMIN]}
            redirectTo={Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsProfile)}
          >
            <GeneralTab />
          </RequireRole>
        ),
        children: [
          {
            path: SettingsRoutePath.SettingsLocationCreate,
            element: <CreateLocationModal />,
          },
          {
            path: SettingsRoutePath.SettingsLocationUpdate,
            element: <UpdateLocationModal />,
          },
          {
            path: SettingsRoutePath.SettingsBusinessNameEdit,
            element: <EditBusinessDetailsModal />,
          },
        ],
      },
      {
        path: SettingsRoutePath.SettingsNotification,
        element: (
          <RequireRole
            roles={[Role.SUPER_ADMIN]}
            redirectTo={Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsProfile)}
          >
            <NotificationsTab />
          </RequireRole>
        ),
      },
      {
        path: SettingsRoutePath.SettingsOnlineBooking,
        element: (
          <RequireRole
            roles={[Role.SUPER_ADMIN]}
            redirectTo={Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsProfile)}
          >
            <OnlineBookingTab />
          </RequireRole>
        ),
      },
      {
        path: SettingsRoutePath.SettingsBilling,
        element: <BillingTab />,
      },
      {
        path: SettingsRoutePath.SettingsProfile,
        element: <ProfileTab />,
      },
      {
        path: SettingsRoutePath.SettingsPetOptions,
        children: [
          {
            index: true,
            element: <Navigate
              to="sizes"
              replace
            />,
          },
          {
            path: 'sizes',
            element: (
              <RequireRole
                roles={[Role.SUPER_ADMIN, Role.ADMIN]}
                redirectTo={Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsProfile)}
              >
                <SizesPage />
              </RequireRole>
            ),
            children: [
              {
                path: 'create',
                element: <CreateSizeCategoryModal />,
              },
              {
                path: ':sizeCategoryId/edit',
                element: <UpdateSizeCategoryModal />,
              },
            ],
          },
          {
            path: 'coats',
            element: (
              <RequireRole
                roles={[Role.SUPER_ADMIN, Role.ADMIN]}
                redirectTo={Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsProfile)}
              >
                <CoatsPage />
              </RequireRole>
            ),
            children: [
              {
                path: 'create',
                element: <CreateCoatTypeModal />,
              },
              {
                path: ':coatTypeId/edit',
                element: <UpdateCoatTypeModal />,
              },
            ],
          },
        ],
      },
    ],
  },
]
